import React from "react";

const ResultDisplay = ({ percentage }) => {
  return (
    <div className="mt-6 text-center">
      <h3 className="text-xl font-semibold text-white">Win Rate Probability:</h3>
      <p className="text-4xl font-bold text-green-600 mt-2 bg-slate-200 w-auto p-5 rounded-2xl shadow-2xl shadow-black">{percentage}%</p>
    </div>
  );
};

export default ResultDisplay;
